import {
  Eye,
  Gift,
  Heart,
  Image,
  ImagePlus,
  MapPin,
  Music,
  Settings,
  Users,
} from 'lucide-react';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';

const EditorTabsList = () => (
  <TabsList className="flex flex-wrap h-auto gap-1">
    <TabsTrigger value="couple" className="flex items-center gap-1">
      <Heart className="w-4 h-4" />
      <span className="hidden sm:inline">Pareja</span>
    </TabsTrigger>
    <TabsTrigger value="ceremonies" className="flex items-center gap-1">
      <Heart className="w-4 h-4" />
      <span className="hidden sm:inline">Ceremonias</span>
    </TabsTrigger>
    <TabsTrigger value="locations" className="flex items-center gap-1">
      <MapPin className="w-4 h-4" />
      <span className="hidden sm:inline">Lugares</span>
    </TabsTrigger>
    <TabsTrigger value="family" className="flex items-center gap-1">
      <Users className="w-4 h-4" />
      <span className="hidden sm:inline">Familia</span>
    </TabsTrigger>
    <TabsTrigger value="gifts" className="flex items-center gap-1">
      <Gift className="w-4 h-4" />
      <span className="hidden sm:inline">Regalos</span>
    </TabsTrigger>
    <TabsTrigger value="gallery" className="flex items-center gap-1">
      <Image className="w-4 h-4" />
      <span className="hidden sm:inline">Galería</span>
    </TabsTrigger>
    <TabsTrigger value="details" className="flex items-center gap-1">
      <ImagePlus className="w-4 h-4" />
      <span className="hidden sm:inline">Detalles</span>
    </TabsTrigger>
    <TabsTrigger value="music" className="flex items-center gap-1">
      <Music className="w-4 h-4" />
      <span className="hidden sm:inline">Música</span>
    </TabsTrigger>
    <TabsTrigger value="settings" className="flex items-center gap-1">
      <Settings className="w-4 h-4" />
      <span className="hidden sm:inline">Ajustes</span>
    </TabsTrigger>
    <TabsTrigger
      value="preview"
      className="flex items-center gap-1 bg-primary/10 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
    >
      <Eye className="w-4 h-4" />
      <span className="hidden sm:inline">Vista Previa</span>
    </TabsTrigger>
  </TabsList>
);

export default EditorTabsList;
